import { Dispatch, SetStateAction } from "react";
import { ProductSelectedProps } from "pages/Quotes/Details/interface";
import { IQuoteDetailItem } from "models/QuoteDetailItem";
import { UpdateApprovedMapAutomaticProps } from "models/MapProduct";

export interface IQuoteCategoryTab {
  state: any;
  quoteId: string;
  hasMore: boolean;
  className?: string;
  isNoSegmented: boolean;
  segmentSelected: string;
  distributionCenters: any;
  customerCode: string | undefined;
  productSelected: ProductSelectedProps[];
  setHasMore: Dispatch<SetStateAction<boolean>>;
  setSegmentSelected: Dispatch<SetStateAction<string>>;
  setRefreshControl: Dispatch<SetStateAction<boolean>>;
  setOldSegmentSelected: Dispatch<SetStateAction<string>>;
  setRemoveAllFromToSegment: Dispatch<SetStateAction<boolean>>;
  showDeParaModal?: (quoteId: string, sequenceNumber: string) => void;
  setProductSelected: Dispatch<SetStateAction<ProductSelectedProps[]>>;
  updateQuoteStatus?: (itemSequenceNumber: number, status: boolean) => void;
  refreshItem?: (field: string, value?: any, sequenceNumber?: string | undefined, filterDetail?: string | undefined, valueFilterDetail?: any) => void;
  reproveMapProduct: (item: IQuoteDetailItem) => Promise<void>;
  approveMapProduct: (id: string, sequenceNumber: number, data: UpdateApprovedMapAutomaticProps) => Promise<void>;
}

export const quoteHeaderLabels = [
  { label: "", key: "isCustomer" },
  { label: "Item", key: "sequenceNumber" },
  { label: "Código", key: "id" },
  { label: "Descrição", key: "description" },
  { label: "", key: "tagsMedicineTipe" },
  { label: "Marca", key: "producer" },
  { label: "Qtd. Total", key: "quantity" },
  { label: "Unidade", key: "unit" },
  { label: "Conversão ", key: "conversionFactor" },
  { label: "Ações", key: "actionBtn" },
];

export interface CategoryTabProps {
  label: string;
  filter: string;
  trackingName: string;
}

export const OrderTabs: { [key: string]: number; } = {
  "Medicamento": 0,
  "Material": 1,
  "default": 99
};